import Vue from 'vue'
import VueRouter from 'vue-router'
import { message } from '@/utils/resetMessage'
import auth from '@/utils/auth'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {

return originalPush.call(this, location).catch(err => err)

}
const appName = "博联图库";
const routes = [{
		path: '/',
		name: 'Index',
		redirect:"/search",
		component: () => import('../views/Index.vue'),
		meta: {
			title: appName
		},
		children: [
			{
				path: 'search',
				name: 'Search',
				component: () => import('../views/Search.vue')
			},
			
			{
				path: 'discover',
				name: 'Discover',
				component: () => import('../views/Discover.vue'),
				meta: {
					title: '发现',
					perms:"common:discover:view"
				},
			},
			{
				path:'mgt',
				name:"Mgt",
				//redirect:"/mgt/myfile",
				component: () => import('../views/mgt/Index.vue'),
				meta: {
					title: '管理后台',
					perms:"system:mgt:view"
				},
				children:[
					{
						path:'myfile',
						name:"Myfile",
						component: () => import('../views/mgt/Myfile.vue'),
						meta: {
							title: '资源库',
							perms:"common:myfile:view"
							
						},
					},
					{
						path:'census',
						name:"Census",
						component: () => import('../views/mgt/Census.vue'),
						meta: {
							title: '统计',
							perms:"system:count:view"
						},
					},
					{
						path:'log',
						name:"Log",
						component: () => import('../views/mgt/Log.vue'),
						meta: {
							title: '统计',
							perms:"system:log:view"
						},
					},
					{
						path:'team',
						name:"Team",
						component: () => import('../views/mgt/team/Team.vue'),
						redirect:"/mgt/team/user",
						meta: {
							title: '团队',
							perms:"system:user:view"
						},
						children:[
							{
								path:'user',
								name:"User",
								component: () => import('../views/mgt/team/User.vue'),
								meta: {
									title: '用户管理',
									perms:"system:user:view"
								},
								
							},
							{
								path:'role',
								name:"Role",
								component: () => import('../views/mgt/team/Role.vue'),
								meta: {
									title: '角色管理',
									perms:"system:role:view"
								},
								
							},
							{
								path:'perms',
								name:"Perms",
								component: () => import('../views/mgt/team/Perms.vue'),
								meta: {
									title: '权限管理',
									perms:"system:perms:view"
								},
								
							},
							{
								path:'dept',
								name:"Dept",
								component: () => import('../views/mgt/team/Dept.vue'),
								meta: {
									title: '部门管理',
									perms:"system:dept:view"
								},
								
							}
						]
						
					},
					{
						path:'options',
						name:"Options",
						component: () => import('../views/mgt/options/Index.vue'),
						redirect:"/mgt/options/config",
						meta: {
							title: '设置',
							perms:"system:options:view"
						},
						children:[
							{
								path:'config',
								name:"Config",
								component: () => import('../views/mgt/options/Config.vue'),
								meta: {
									title: '设置',
									perms:"system:config:view"
								},
							},
							{
								path:'classify',
								name:"Classify",
								component: () => import('../views/mgt/options/Classify.vue'),
								meta: {
									title: '行业管理',
									perms:"common:classify:view"
								},
							},
							{
								path:'tag',
								name:"Tag",
								component: () => import('../views/mgt/options/Tag.vue'),
								meta: {
									title: '标签管理',
									perms:"common:tag:view"
								},
							},
							{
								path:'origin',
								name:"Origin",
								component: () => import('../views/mgt/options/Origin.vue'),
								meta: {
									title: '来源管理',
									perms:"common:origin:view"
								},
							}
						]
					},
					{
						path:'mine',
						name:"Mine",
						component: () => import('../views/mgt/mine/Index.vue'),
						//redirect:"/mgt/mine/collect",
						meta: {
							title: '我的',
							perms:'common:mine:view'
						},
						children:[
							{
								path:'collect',
								name:"Collect",
								component: () => import('../views/mgt/mine/Collect.vue'),
								meta: {
									title: '我的收藏',
									perms:'common:mine:collect:view'
								},
							},
							{
								path:'recycle',
								name:"Recycle",
								component: () => import('../views/mgt/mine/Recycle.vue'),
								meta: {
									title: '我的回收站',
									perms:'common:mine:recycle:view'
								},
							},
							{
								path:'share',
								name:"Share",
								component: () => import('../views/mgt/mine/Share.vue'),
								meta: {
									title: '我的分享',
									perms:'common:mine:share:view'
								},
							},
							{
								path:'down',
								name:"Down",
								component: () => import('../views/mgt/mine/Down.vue'),
								meta: {
									title: '我的下载',
									perms:'common:mine:download:view'
								},
							},
							{
								path:'changepwd',
								name:"ChangePwd",
								component: () => import('../views/mgt/mine/ChangePwd.vue'),
								meta: {
									title: '修改密码',
									perms:'common:mine:changepwd'
								},
							}
						]
					}
				]
				
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/Login.vue'),
		meta: {
			title: '用户登录'
		}
	},
	{
		path: '/share',
		name: 'openShare',
		component: () => import('../views/Share.vue'),
		meta:{
			title:"查看分享"
		}
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})


router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title +" - "+appName
	}
	if(to.meta.perms!=undefined){
		if(!auth.checkPerms(to.meta.perms)){
			message.error("您没有权限访问该页面");
			next({
				path:'/'
			})
		}else{
			next();
		}
		
	}else{
		next();
	}
	
	
})

export default router
